import React from 'react';
import './loader.scss';

export default function Loader() {
  return (
    <div className="loader" data-testid="loader">
      <div className="loader__element" />
    </div>
  );
}
